import dynamic from 'next/dynamic'

const DynamicContactForm = dynamic(
    () => import('@components/display/user/ContactForm'),
    { ssr: false },
)

const ContactForm = (props) => <DynamicContactForm {...props} />

export default ContactForm